export default __webpack_public_path__ + "static/media/BuzzedIn.1804b1e2.mp3";